import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/cta-button-icon.svg")